module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-11.ff756dbe.jpg";